<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" id="modal-cambio">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>Cambio de programa</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <b>Estudiante: </b><b class="text-primary"> {{estudiante}} </b> <br>
              <b>Actual: </b><b class="text-primary"> {{prog}} </b>
              <hr>
               
                <form class="form-horizontal">
                  <small>Seleccione la sede del nuevo programa</small>
                  <div class="form-group">
                        <label for="inputEmail3" class="col-sm-2 control-label">Sede: </label>
                        <div class="col-sm-10"> <Sedes :model="sede"/> </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('programa.id')}">
                        <label for="inputEmail3" class="col-sm-2 control-label">Programa: </label>
                        <div class="col-sm-10">
                          <multiselect class="form-control" v-model="programa" 
                            :options="programas" track-by="id" label="nombre" :searchable="false" 
                            :close-on-select="true" :show-labels="false" :hide-selected="true" 
                            placeholder="Seleccione el programa..."></multiselect>
                        </div>
                        <div class="error" v-if="validation.hasError('programa.id')"> {{validation.firstError('programa.id')}} </div>
                    </div>

                    <small>Ingrese los montos(total) con el que ingresara al nuevo programa:</small>
                    <div class="form-group" :class="{'has-error': validation.hasError('cambio.monto_matricula')}">
                        <label for="inputEmail3" class="col-sm-2 control-label">Matricula: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" type="number" v-model="cambio.monto_matricula"> </div>
                        <div class="error" v-if="validation.hasError('cambio.monto_matricula')"> {{validation.firstError('cambio.monto_matricula')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('cambio.monto_colegiatura')}">
                        <label for="inputEmail3" class="col-sm-2 control-label">Colegiatura: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" type="number" v-model="cambio.monto_colegiatura"> </div>
                        <div class="error" v-if="validation.hasError('cambio.monto_colegiatura')"> {{validation.firstError('cambio.monto_colegiatura')}} </div>
                    </div>
                    <div class="form-group" :class="{'has-error': validation.hasError('cambio.monto_certificacion')}">
                        <label for="inputEmail3" class="col-sm-2 control-label">Certificacion: </label>
                        <div class="col-sm-10"> <input class="form-control input-sm" type="number" v-model="cambio.monto_certificacion"> </div>
                        <div class="error" v-if="validation.hasError('cambio.monto_certificacion')"> {{validation.firstError('cambio.monto_certificacion')}} </div>
                    </div>
                    
                </form>

                <p class="text-center text-danger"> {{msg}} </p>
            </div>
            
            <Alertas 
                ref="alertar" 
                v-bind:msgSuccess="'El cambio de progrma se realizo satisfactoriamente.'"
                v-bind:msgLoading="'Aplicando...'"
                />
            <div class="modal-footer">
                <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Enviar</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'
import {parseJsonError} from '@/components/Utils.js'
import Alertas from '@/components/AAlertas.vue'
import Sedes from '@/components/ASedes'
import gql from 'graphql-tag'

export default {
  props:{ model:{type:Object,required:true},// {id:111,idasesor:4444}
    }, 
  data(){
    return{
      sede: {idsede:{},idusuario:[]},
      programa:{id:null},
      programas:[],
      msg:'',
      estudiante: '',
      prog:'',
      activo:true,
      cambio:{
        idprograma: 256,
        monto_matricula: 0,
        monto_colegiatura: 4000,
        monto_certificacion: 1700,
      }
    }
  },
  components:{ Sedes,Alertas },
  validators: {
    'programa.id'(value){ return Validator.value(value).required(); },
    'cambio.monto_matricula'(value){ return Validator.value(value).required(); },
    'cambio.monto_colegiatura'(value){ return Validator.value(value).required(); },
    'cambio.monto_certificacion'(value){ return Validator.value(value).required(); },
  },
  watch:{
    'sede.idsede': function(){
      if( this.sede.idsede.id ) this.cargarProgramas();
    },
    'model.ins.estudiante': function(){
      this.estudiante = this.model.ins.estudiante.nombres;
      this.prog = this.model.ins.programa.postgrado.nombre;
    }
  },
  methods:{
    async cargarProgramas(){
      this.programas = [];
      var vue = this;
      var sql = gql`query{ getProgramas(idsede:${this.sede.idsede.id},estado:true){id,postgrado{nombre},nombre_compuesto,fase,estado} }`;
      await this.$apollo.query({
      query: sql,
      }).then((data) => {
        var datos = [];
        // window.console.log( datos );
        data.data.getProgramas.forEach( function(e){
          if( e.fase < 2) datos.push( {id:e.id,nombre:e.nombre_compuesto} )
        })
        this.programas = datos;
        
        //window.console.log( window.stringifyObject( vue .datos ) )
      }).catch((error) => {
        // window.console.error(error)
        vue.$notify( parseJsonError( error,'getProgramas' ) )
      })
    },
    submit(){
      var vue = this;
      this.$validate().then((success) => {
        if( success ){
          var obj = window.Object.assign({},this.cambio);
          obj.id = this.model.id;
          obj.idasesor = this.model.idasesor;
          obj.idprograma = this.programa.id;
          obj.monto_matricula = parseInt( obj.monto_matricula );
          obj.monto_colegiatura = parseInt( obj.monto_colegiatura );
          obj.monto_certificacion = parseInt( obj.monto_certificacion );
          window.console.log( window.stringifyObject(obj) )
          vue.realizaCambio( obj )
        }else{
          vue.msg = 'Revise los datos'
        }
      })
    },
    async realizaCambio( obj ){
      this.activo = false;
      var vue = this;
      var sql = gql`mutation{ cambioInscripcion(input:${window.stringifyObject(obj)}){ ok inscripcion{id,estado_ins} errors{message} }}`;
      window.console.log( sql )
      await this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        var res = data.data.cambioInscripcion;
        window.console.log(res)
        if( res.ok ){
          this.model.ins.estado_ins = res.inscripcion.estado_ins;
          window.$('#modalcam').modal('toggle')
        }else{
          var errores = JSON.stringify(res.errors);
          var ob = JSON.parse( errores );
          var vals = '';
          ob.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.msg = '';
          vue.activo = true;
          vue.$refs.alertar.invalido( vals );
        }
        
      }).catch((error) => {
        window.console.error(error)
        vue.$notify( parseJsonError( error,'cambioInscripcion' ) )
      })
    }
  },
  mounted(){
    var vue = this;
    window.$('#modalcam').on('hidden.bs.modal',function(){
      vue.msg = ''
      //vue.programa = {}
      vue.activo = true;
      vue.$refs.alertar.reset();
    })
  }
}
</script>